import React from 'react';

import { ContentLayout } from './components';
import AgentInputs from './AgentInputs';
import SendNotifications from './SendNotifications';
import Permissions from './Permissions';

const AgentContent: React.FC = () => (
  <ContentLayout
    detailsSection={<AgentInputs />}
    notificationsSection={<SendNotifications />}
    permissionsSection={<Permissions />}
  />
);

export default AgentContent;
